import { useCallback } from "react";

import { langCodeToJapanese } from "@/lib/chillnn/lang-code";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { ExistingOptionI18nUpdate_EditPage_Mutation } from "./mutation";
import { viewModelToOptionInputConverter } from "../../_common/view-model-to-option-i18n-input";

import type { ProductOptionI18nFormModel } from "../../../type";

type Props = {
	resetForm: () => void;
};

export const useOptionI18nEditMutation = ({ resetForm }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(ExistingOptionI18nUpdate_EditPage_Mutation);

	const onUpdate = useCallback(
		async (
			viewModel: ProductOptionI18nFormModel["ViewModel"], //
		) => {
			showLoadingScreenCallback();

			const input = viewModelToOptionInputConverter({ viewModel });

			const { lang } = viewModel;
			const langCodeText = langCodeToJapanese(lang);

			const { errors } = await mutationFunc({
				variables: {
					input,
				},
			}).finally(hideLoadingScreenCallback);

			if (!errors) {
				notifyUserEventInfo({
					title: `オプション（${langCodeText}）を更新しました`,
				});

				resetForm();
			}
		},
		[hideLoadingScreenCallback, mutationFunc, resetForm, showLoadingScreenCallback],
	);

	return { onUpdate };
};
